import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from '../translations';
import { SettingsContext } from './SettingsContext';

interface Translations {
  [key: string]: {
    [key: string]: string;
  };
}

interface TranslationContextProps {
  t: (key: string) => string;
  translateMonth: (month: string) => string;
}

export const TranslationContext = createContext<TranslationContextProps>({ t: (key: string) => key, translateMonth: (month: string) => month });

interface TranslationProviderProps {
  children: React.ReactNode;
}

export const TranslationProvider: React.FC<TranslationProviderProps> = ({ children }) => {
  const { language } = useContext(SettingsContext);
  const [currentLanguage, setCurrentLanguage] = useState(language);

  useEffect(() => {
    setCurrentLanguage(language);
  }, [language]);

  const t = (key: string) => {
    return (translations as Translations)[currentLanguage][key] || key;
  };

  const translateMonth = (month: string) => {
    const monthNames = Object.keys(translations[currentLanguage as keyof typeof translations]);
    let translatedMonth = month;
    monthNames.forEach((monthName) => {
      if (month.includes(monthName)) {
        translatedMonth = month.replace(monthName, (translations[currentLanguage as keyof typeof translations] as { [key: string]: string })[monthName]);
      }
    });
    return translatedMonth;
  };

  return (
    <TranslationContext.Provider value={{ t, translateMonth }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => useContext(TranslationContext);
